import { createAction } from '@reduxjs/toolkit';
import { RESET_DEFAULT_CLIENT_DATA, SET_MAIN_GUEST_INFO } from './constants';

export const setMainInfoAction = createAction(SET_MAIN_GUEST_INFO);
export const resetDefaultClientDataAction = createAction<boolean>(
  RESET_DEFAULT_CLIENT_DATA,
);
